import { useState, type ReactNode } from "react";
import { createComposerDraftStore } from "./composerDraftStore";
import { ComposerDraftContext } from "./useComposerDraftField";

export function ComposerDraftProvider({ children }: { children: ReactNode }) {
  const [store] = useState(createComposerDraftStore);
  return <ComposerDraftContext.Provider value={store}>{children}</ComposerDraftContext.Provider>;
}
